module.exports = __webpack_public_path__ + "img/icon_apple.878371ea.svg";